import { Tag } from 'antd'
import classNames from 'classnames'

import type { PickerEntry, PickerKey } from './issuePicker.types'
import { PICKER_TEXT, getPickerKey } from './issuePicker.utils'
import styles from './medicalissues.module.scss'

type PickerChipsProps = {
  chosen: PickerEntry[]
  disabled?: boolean
  onRemove: (key: PickerKey) => void
}

// Same closable antd Tag the treatment code-select draws its chips with.
export const PickerChips = ({ chosen, disabled = false, onRemove }: PickerChipsProps) => {
  if (!chosen.length) return null

  return (
    <div className={styles.tags}>
      {chosen.map((entry) => {
        const key = getPickerKey(entry)
        const isProblem = entry.kind === 'problem'
        return (
          <Tag
            key={key}
            closable={!disabled}
            onClose={() => onRemove(key)}
            className={classNames(styles.tag, isProblem ? styles.tagProblem : styles.tagProcedure)}>
            <span className={styles.tagKind}>
              {isProblem ? PICKER_TEXT.problemKind : PICKER_TEXT.procedureKind}
            </span>
            <span className={styles.tagLabel}>{entry.label}</span>
          </Tag>
        )
      })}
    </div>
  )
}
